export class ExpiredPasswordError extends Error {}

export class InternalServerError extends Error {}
